var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","max-width":"300px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.sync}},on),[_c('v-icon',{class:{ 'syncing': _vm.syncing }},[_vm._v("mdi-sync")])],1)]}}])},[_c('span',[(_vm.syncing)?[_vm._v("Syncing...")]:[_vm._v(_vm._s(_vm.text))]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }